<form
    nz-form
    [formGroup]="validateForm"
    (ngSubmit)="submitForm()"
>
    <nz-form-item *ngFor="let control of listOfControl; let i = index">
        <nz-form-control nzErrorTip="Please input or delete this field.">
            <input
                class="item-input"
                nz-input
                placeholder="placeholder"
                [attr.id]="control.id"
                [formControlName]="control.controlInstance"
            />
            <i
                nz-icon
                nzType="minus-circle"
                nzTheme="outline"
                class="dynamic-delete-button"
                (click)="removeField(control, $event)"
            ></i>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-control>
            <button
                nz-button
                nzType="dashed"
                class="add-button"
                (click)="addField($event)"
            >
                <i class="fa-solid fa-plus"></i>&nbsp;Add field
            </button>
        </nz-form-control>
    </nz-form-item>
</form>